import { AfterViewInit, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { FooterLink } from 'visana-ui-library';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'ssc-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements AfterViewInit {
  @Input() public showContactButton = false;
  public footerLinks: FooterLink[] = [];

  constructor(private translateService: TranslateService) {
    this.footerLinks = [
      {
        href: this.translateService.instant('FOOTER.IMPRINT_LINK'),
        text: this.translateService.instant('FOOTER.IMPRINT'),
        target: '_blank',
      },
      {
        href: this.translateService.instant('FOOTER.LEGAL_INFORMATION_LINK'),
        text: this.translateService.instant('FOOTER.LEGAL_INFORMATION'),
        target: '_blank',
      },
      {
        href: this.translateService.instant('FOOTER.DATA_PROTECTION_LINK'),
        text: this.translateService.instant('FOOTER.DATA_PROTECTION'),
        target: '_blank',
      },
    ];
  }

  public ngAfterViewInit(): void {
    this.showContactButton = true;
  }
}
